export enum BannerActionOpenModal {
  loginAndSignup = '__ACTION_OPEN_LOGIN_MODAL__',
}
